var heading_default = {
  "fontElementMap": "slEtG",
  "elementSpacing": "_4I-z2",
  "headerOne": "YDtHZ _4I-z2",
  "headerTwo": "_6SJy- _4I-z2",
  "headerThree": "WyZbu _4I-z2",
  "headerFour": "_2yUnT _4I-z2",
  "headerFive": "iRMyA _4I-z2",
  "headerSix": "KdMEj _4I-z2",
  "child": "ILVdc"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
